import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("web-tree-sitter");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
